// src/i18n/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(HttpBackend) // Load translations using http (default public/assets)
    .use(LanguageDetector) // Detect user language
    .use(initReactI18next) // Pass i18n instance to react-i18next
    .init({
        fallbackLng: 'en',
        debug: import.meta.env.DEV,
        supportedLngs: ['en', 'sv'], // Supported languages: English and Swedish
        load: 'languageOnly', // Resolve regional codes (sv-SE, en-GB) to their base language
        interpolation: {
            escapeValue: false
        },
        backend: {
            loadPath: '/locales/{{lng}}/translation.json'
        },
        detection: {
            order: [
                'querystring',
                'cookie',
                'localStorage',
                'sessionStorage',
                'navigator',
                'htmlTag',
                'path',
                'subdomain'
            ],
            caches: ['localStorage', 'cookie']
        }
    });

export default i18n;
